import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import * as d3 from "d3";
import HoverableIcon from "../../../../components/Buttons/HoverableIcon ";
import ReusableAgGrid from "../../../../components/AgGrid/AgGrid";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
}));

const QBRDrilldown = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  const classes = useStyle();

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  // Column config for the ag-grid table
  const columnConfig = [
    {
      label: "Account",
      field: "Name",
      type: "string", // Used for formatting
      flex: 1.5,
    },
    {
      label: "Account Segment",
      field: "Account_Segment",
      type: "string",
      flex: 0.6,
    },
    {
      label: "CARR",
      field: "CARR",
      type: "currency",
      flex: 0.6,
    },
    {
      label: "Account Type",
      field: "Account_Type",
      type: "string",
      flex: 0.6,
    },
    {
      label: "QBR Date",
      field: "QBR_Date_c",
      type: "date",
      flex: 0.6,
    },
    {
      label: "QBR Frequency",
      field: "QBR_Frequency_c",
      type: "string",
      flex: 0.6,
    },
  ];

  return (
    <Grid container className={classes.root}>
      {props.body ? (
        <React.Fragment>
          <Grid
            container
            justify="space-betweeen"
            className={classes.titleContainer}
            xs={12}
          >
            <Grid
              item
              container
              xs={10}
              justify="flex-start"
              alignItems="flex-end"
            >
              <Typography variant="body1" style={{ fontWeight: "600" }}>
                Number of opportunities:{" "}
                {d3.format(",")(props.body.count_acv[0].count)}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ACV: ${" "}
                {d3.format(",")(Math.round(props.body.count_acv[0].CARR))}
              </Typography>
            </Grid>
            <Grid
              direction="column"
              item
              container
              xs={2}
              justify="flex-end"
              alignItems="flex-end"
              alignContent="flex-end"
            >
              <Grid item justify="flex-end" style={{ paddingBottom: "1rem" }}>
                <button style={{ border: "none" }} onClick={handleExport}>
                  <HoverableIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>

          <ReusableAgGrid
            rowData={props.body.opportunities}
            columnConfig={columnConfig}
            isExportable={true}
            header={props.header}
            rawColumnDataForExport={columnConfig}
            exportTrigger={exportTrigger}
          />
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default QBRDrilldown;
